import { jsxs, jsx } from "react/jsx-runtime";
import { useHeaderContext } from "../Header.js";
import styles from "./SubmenuArticle.module.scss.js";
function SubmenuArticle(props) {
  var _a;
  const context = useHeaderContext();
  return /* @__PURE__ */ jsxs(
    "a",
    {
      className: styles.root,
      href: context.resolveURL(props.url),
      "aria-label": props.title,
      onClick: (e) => context.emitLinkClickEvent(e, {
        interaction_name: "header_submenu_article_click",
        custom_tracking_fields: {
          parent: props.parent
        }
      }),
      ...props.openInNewTab && { target: "_blank", rel: "noreferrer" },
      children: [
        ((_a = props.image) == null ? void 0 : _a.url) && /* @__PURE__ */ jsx(
          "img",
          {
            className: styles.image,
            src: props.image.url,
            alt: props.image.alt,
            loading: "lazy",
            width: 96
          }
        ),
        /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("div", { className: styles.title, children: props.title }),
          /* @__PURE__ */ jsx("p", { className: styles.description, children: props.description })
        ] })
      ]
    }
  );
}
export {
  SubmenuArticle
};
